import {EmployeeTerminationType} from "@app/shared/enums/employee-termination-type";

export class EmployeeTermination {
  id: number;
  version: number;
  userId: number;
  termType: EmployeeTerminationType;
  termDate: string;
  reasonId: number;
  reasonLabel: string;
  reasonDescription: string;
  termNote: string;
  lastModifiedById?: number;
  lastModifiedBy?: string;
  lastModifiedOn?: Date;
}
